<template>
    <section id="contact" class="bg-white">
        <div class="container">
            <div class="row">
                <div class="col-md-6 text-center">
                    <h3 class="display-block font-weight-300 letter-spacing-1 title-large"><b>Har du spørgsmål?</b><br>Kontakt vores erhvervscenter:</h3>
                    <div class="margin-5 no-margin-bottom no-margin-rl">
                        <br>
                        <!--<div>
                            <i class="fa fa-envelope-o display-block text-base-color xs-title-large title-extra-large-2"></i>
                            <span class="display-block margin-5 no-margin-bottom no-margin-rl text-gray-dark-2 xs-text-large title-small">nk@vw-amager.dk</span>
                        </div>
                        <br><br>-->
                        <div>
                            <i class="fa fa-phone display-block text-base-color xs-title-large title-extra-large-2"></i>
                            <span class="display-block margin-5 no-margin-bottom no-margin-rl text-gray-dark-2 xs-text-large title-small mb50">{{ phone }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 text-center">
                    <div class="fb-page" :data-href="'https://www.facebook.com/' + facebookUrl" data-tabs="timeline" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="false">
                        <blockquote :cite="'https://www.facebook.com/' + facebookUrl" class="fb-xfbml-parse-ignore">
                            <a :href="'https://www.facebook.com/' + facebookUrl">
                                {{ title }}
                            </a>
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            phone: {
                type: String,
                required: true
            },
            facebookUrl: {
                type: String,
                required: true
            }
        }
    }
</script>
<style scoped>
.mb50{
    margin-bottom: 50px !important;
}
</style>



// WEBPACK FOOTER //
// contact.vue?f287b75a